<div class="d-flex justify-content-between">
  <app-breadcrumb id="MainActivity" *ngIf="qmsservice.refereshBreadCrumb"></app-breadcrumb>
  <div class="d-flex gap-4 align-items-center">
    <div class="">
    </div>
    <div class="d-flex justify-content-end align-items-center gap-2">
      <p class="group" *ngIf="qmsservice.groupNameAndValue.length>0">Group:</p>
      <p class="group" *ngIf="qmsservice.groupNameAndValue.length>0">{{qmsservice.groupNameAndValue[0].displayExp}}</p>
      <div (click)="openGroupMethod()" (keydown.enter)="openGroupMethod()"
        *ngIf="qmsservice.groupNameAndValue.length>0">
        <img src="../../../assets/img/cr_module/Edit.svg" width="24px" height="24px" alt="edit" />
      </div>
    </div>
    <div class="d-flex gap-2">


    </div>
  </div>
</div>
<app-top-navigation [hidden]="true"></app-top-navigation>